import _ from 'lodash';

let InsuranceSuiteMetadata;
const numSort = (a, b) => {
  return a - b;
};

const ensureMortgagePosition = (additionalInterests) => {
  const mortagagees = _.filter(additionalInterests, (ai) => {
    return ai.mortgagePosition_ext;
  });
  if (mortagagees && mortagagees.length > 0) {
    const theTypeList = InsuranceSuiteMetadata.pc['typekey.MortgagePositionType_ext'].value // DE16373
    const allPriorities = _.map(theTypeList.codes, tc => tc.priority).sort(numSort);
    const currentOrder = _.map(mortagagees, (mortgagee) => {
      const code = _.find(theTypeList.codes, (code) => code.code === mortgagee.mortgagePosition_ext)
      return code.priority;
    }).sort(numSort);
    const diff = allPriorities.length - (_.difference(allPriorities, _.uniq(currentOrder))).length;
    const last = _.max(currentOrder);
    return allPriorities[diff - 1] === last;
  }
  return true;
};
const ensureUniqueMortgagePosition = (additionalInterests) => {
  if (_.isEmpty(additionalInterests)) {
    return true;
  }
  const positions = _.groupBy(additionalInterests, val => val.mortgagePosition_ext);
  const lengths = _.map(positions, val => val.length);
  return _.isEmpty(_.filter(lengths, val => val !== 1));
};

export default {
  'ensureMortgagePosition': ensureMortgagePosition,
  'ensureUniqueMortgagePosition': ensureUniqueMortgagePosition,
  'setInsuranceSuiteMetadata': (ism) => {
    InsuranceSuiteMetadata = ism;
  }
};
